import classNames from 'classnames'
import { ReactNode } from 'react'

export const FormError = ({
  id,
  showError,
  errorMessage,
  className
}: {
  id?: string
  showError?: boolean
  errorMessage: ReactNode
  className?: string
}) => {
  return (
    <div role="alert">
      <span
        id={id}
        className={classNames(
          'whitespace-normal text-danger-dark italic block text-xs mt-1',
          !showError && 'hidden',
          className
        )}
      >
        {errorMessage}
      </span>
    </div>
  )
}
